/// *** System import ***///
import { Component, ViewChild } from '@angular/core';
import { Content, NavParams, NavController, PopoverController, ToastController } from 'ionic-angular';
import { RESOURCE_CACHE_PROVIDER } from '@angular/platform-browser-dynamic';
/// *** Custom import ***///

import { Globals } from '../../../app/globals';
import { SessionProvider } from '../../../providers/session';
import { MainProcessProvider } from '../../../providers/processes/main';
import { Market_SessionInstrumentStore } from './sessionInstrument.store';
import { Market_SessionInstrumentIntradayPage } from './intraday/intraday';
import { Market_SessionInstrumentDepthPage } from './depth/depth';
import { Market_SessionInstrumentTradesPage } from './trades/trades';
import { Market_SessionInstrumentHistoryPage } from './history/history';
import { Trading_OrderPage } from '../../trading/order/order';

@Component({
  selector: 'page-market-sessionInstrument',
  templateUrl: 'sessionInstrument.html',
})
export class Market_SessionInstrumentPage {
  @ViewChild(Content) private content: Content;
 
  private isBuzy = true;
  private intraDayTab = Market_SessionInstrumentIntradayPage;
  private marketDepthTab = Market_SessionInstrumentDepthPage;
  private transactionsTab = Market_SessionInstrumentTradesPage;
 
  constructor(
    // *** System
    private navParams: NavParams,
    private navCtrl: NavController,
    private popoverCtrl: PopoverController,
    private toastCtrl: ToastController,
    // *** Custom
    private globals: Globals,
    private session: SessionProvider,
    private mainProcess: MainProcessProvider,
    private store: Market_SessionInstrumentStore) {
    this.store.configParams(
      {
        iSINCode: this.navParams.data,
      }, false);
  }

  // *** Evénement de chargement
  ngOnInit() {
    try {
      this.isBuzy = true;
      this.store.loadParams().then(
        (succeed) => {
          this.store.load().then(
            (succeed) => {
              this.isBuzy = false;
              this.content.resize();
              this.content.scrollToTop();
            },
            (error) => { this.isBuzy = false; }
          );
        },
        (error) => { this.isBuzy = false; }
      );
    }
    catch (error) {
      this.isBuzy = false;
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }

  // *** Evénement de clôture
  ionViewWillUnload() {
    try {
      this.store.reset();
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
    }
  }
 
  // *** Afficher la fenêtre d'achat
  private _presentBuyOrder() {
    try {
      this.isBuzy = true;
      let params = {
        isNew: true,
        orderSide: 2,
        iSINCode: this.store.params.iSINCode
      }
      this.navCtrl.push(Trading_OrderPage, params);
      this.isBuzy = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Afficher la fenêtre de vente
  private _presentSellOrder() {
    try {
      this.isBuzy = true;
      let params = {
        isNew: true,
        orderSide: 1,
        iSINCode: this.store.params.iSINCode
      }
      this.navCtrl.push(Trading_OrderPage, params);
      this.isBuzy = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Ajouter/Retirer des favoris
  private _setFavorite() {
    try {
      this.isBuzy = true;
      this.store.activeSessionInstrument.IsFavorite = !this.store.activeSessionInstrument.IsFavorite;
      this.mainProcess.toggleFavorite(this.store.params.iSINCode).then(
        (succeed) => { this.isBuzy = false; },
        (error) => { this.isBuzy = false; }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Afficher l'historique des cours
  private _presentPriceHistory() {
    try {
      this.isBuzy = true;
      this.navCtrl.push(Market_SessionInstrumentHistoryPage);
      this.isBuzy = false;
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      this.isBuzy = false;
    }
  }

  // *** Recharger les données
  private _doRefresh(refresher) {
    try {
      this.isBuzy = true;
      this.store.load(true).then(
        (result) => {
          refresher.complete();
          this.content.resize();
          this.content.scrollToTop();
          this.isBuzy = false;
        },
        (error) => {
          refresher.complete();
          this.isBuzy = false;
        }
      );
    }
    catch (error) {
      this.globals.showUnknownError(this.toastCtrl, error);
      refresher.complete();
      this.isBuzy = false;
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/market/sessionInstrument/sessionInstrument.ts